

















































































import Vue from 'vue';
import { OutlinedTextInput, OutlinedSelect, Button, Icon, Toast, Checkbox } from '@/components/ds';
import { formatCreditCardNumber, formatCpf, formatCVV } from '@/helpers/formatters';
import LoadingPage from '@/components/LoadingPage.vue';
import Analytics from '@/helpers/analytics';
import pipeline from '@/pipeline';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { PaymentInfoTrackingModel } from '@/helpers/paymentInfoTracking';

export interface CreditCardFormEvent {
  ownerName?: string;
  ownerCPF?: string;
  flag?: string;
  number?: string;
  cvv?: string;
  month?: string;
  year?: string;
}

export default Vue.extend({
  components: {
    OutlinedTextInput,
    OutlinedSelect,
    Button,
    Icon,
    LoadingPage,
    Toast,
    Checkbox,
  },
  props: {
    paymentInfoTracking: {
      type: Object as () => PaymentInfoTrackingModel,
      required: true,
    },
    studentEmail: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mask: {
        creditCard: formatCreditCardNumber,
        cpf: formatCpf,
        cvv: formatCVV,
      },
      creditCard: {
        ownerName: this.$store.getters.getCreditCard?.ownerName || '',
        flag: this.$store.getters.getCreditCard?.flag || '',
        number: this.$store.getters.getCreditCard?.number || '',
        cvv: this.$store.getters.getCreditCard?.cvv || '',
        month: this.$store.getters.getCreditCard?.month || '',
        year: this.$store.getters.getCreditCard?.year || '',
        ownerCPF: this.$store.getters.getCreditCard?.ownerCPF || '',
      },
      shouldRecurringCreditCard: false,
      isLoading: false,
      error: false,
    };
  },
  computed: {
    getFlagOptions(): string[] {
      return this.$store.getters.flagOptions || [];
    },
    getMonthOptions(): string[] {
      return this.$store.getters.monthOptions || [];
    },

    getYearOptions(): string[] {
      return this.$store.getters.yearOptions || [];
    },

    isFinishEnabled(): boolean {
      return Object.values(this.creditCard).every(Boolean) && !this.error;
    },
    studentAcademicRecord(): string {
      return this.$store.getters.backofficeStudentAcademicRecord;
    },
  },
  created() {
    this.$store.dispatch('PULL_FLAG_OPTIONS');
    this.$store.dispatch('PULL_MONTH_OPTIONS');
    this.$store.dispatch('PULL_YEAR_OPTIONS');
  },
  methods: {
    inputHandler() {
      const event: CreditCardFormEvent = this.creditCard;
    },
    poolingEnrollmentStatus(): Promise<string> {
      return new Promise((resolve, reject) => {
        let tryCount = 0;
        const maxTryCount = 5;
        const poolingIntervalRate = 4000;
        const interval: any = setInterval(async () => {
          try {
            tryCount++;

            await this.$store.dispatch('GET_ENROLLMENT');

            const { enrollmentStatus } = this.$store.getters;

            if (enrollmentStatus !== 'pendingPayment' || tryCount >= maxTryCount) {
              clearInterval(interval);
              resolve(enrollmentStatus);
            }
          } catch (err) {
            clearInterval(interval);
            reject(err);
          }
        }, poolingIntervalRate);
      });
    },
    async finishHandler() {
      try {
        const { creditCard } = this;
        this.isLoading = true;

        await this.$store.dispatch('UPDATE_CREDIT_CARD', {
          creditCard: { ...creditCard, isRecurrentCreditCard: this.shouldRecurringCreditCard },
        });

        await this.$store.dispatch(AnalyticsActions.PAYMENT_SENT, {
          paymentMethod: 'Cartao de credito',
          isRecurrentCreditCard: this.shouldRecurringCreditCard,
          academicRecordId: this.studentAcademicRecord,
          ...this.paymentInfoTracking,
        });

        const { enrollmentId, course, enrollmentStatus } = this.$store.getters;

        const currentEnrollmentStatus =
          enrollmentStatus === 'pendingPayment'
            ? await this.poolingEnrollmentStatus()
            : enrollmentStatus;

        if (['success', 'pendingPayment'].includes(currentEnrollmentStatus))
          Analytics.trackEcommerceTransaction(enrollmentId, course, {
            academicRecordId: this.studentAcademicRecord,
            paymentMethod: 'Cartao de credito',
            isRecurrentCreditCard: this.shouldRecurringCreditCard,
            email: this.studentEmail,
            ...this.paymentInfoTracking,
          });

        pipeline.next({ status: currentEnrollmentStatus });
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
